import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import { Component } from 'react'

import { IFreightieJSON, TUsers } from '../../Actors'
import { TIdType, TSubscription } from '../SubscriptionModel'
import { MembersEdit } from './MembersEdit'
import { MembersList } from './MembersList'

interface IMembersProps {
  subscription: TSubscription
  addSubscriber: (id: string, idType: TIdType) => Promise<void>
  removeSubscriber: (id: string, idType: TIdType) => void
  users: TUsers
  getFreighties?: (name: string) => Promise<IFreightieJSON[]>
  disableModifySubscribers?: boolean
  showDisplayName?: boolean
}
@observer
export class Members extends Component<IMembersProps> {
  @observable
  open: boolean = false

  @action
  setOpen = (open: boolean): void => {
    this.open = open
  }

  render() {
    const { subscription, addSubscriber, disableModifySubscribers, getFreighties, showDisplayName } = this.props
    return (
      <div>
        <MembersList
          subscription={subscription}
          removeSubscriber={this.props.removeSubscriber}
          openDialog={() => this.setOpen(true)}
          disableModifySubscribers={disableModifySubscribers}
          showDisplayName={showDisplayName}
        />
        <MembersEdit
          title="members-edit-title"
          open={this.open}
          handleClose={() => this.setOpen(false)}
          subscription={subscription}
          addSubscriber={addSubscriber}
          removeSubscriber={this.props.removeSubscriber}
          users={subscription.getUniqueUsers(this.props.users)}
          getFreighties={getFreighties}
        />
      </div>
    )
  }
}
